import { render, staticRenderFns } from "./alertas-del-hogar.vue?vue&type=template&id=2d28585d&"
import script from "./alertas-del-hogar.vue?vue&type=script&lang=ts&"
export * from "./alertas-del-hogar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports